import { SelectedTemplateType } from '@zonofi/zono-money-store';
import { SVGS } from '../assets';

export const templates = [
  {
    title: 'Thumbnail',
    image: SVGS.ThumbnailViewTemplate,
    width: 206,
    fixedSize: true,
    description: 'PDF will show all the variants present for the Parent',
    template: SelectedTemplateType.PRODUCT_CATALOGUE,
  },
  {
    title: 'Parent & Variant',
    image: SVGS.ProductCatalogueViewTemplate,
    fixedSize: true,
    description: 'PDF will show the Parent product & its variants',
    template: SelectedTemplateType.PARENT_PRODUCT_CATALOGUE,
  },
  {
    title: 'Excel',
    image: SVGS.ExcelViewTemplate,
    fixedSize: false,
    description: 'PDF will show all the variants in the tabular format',
    template: SelectedTemplateType.CATALOGUE_LIST_VIEW,
  },
];
